import { useState } from 'react';
import { useSnackbar } from 'notistack';

import HttpClient from '../../shared/infrastructures/clients/http.client';
import { extractTranslatedApiErrorMessage } from '../../shared/utils/translate-api-error.util';
import { DeliveryZone } from '../types/delivery-zone.type';
import { ADMIN_DELIVERY_ZONES_API_PATHS } from '../constants/delivery-zones-api-paths.constants';

type UseRestoreDeliveryZoneResult = {
  restoreDeliveryZone: (deliveryZoneId: string) => Promise<DeliveryZone | null>;
  isSubmitting: boolean;
};

export function useRestoreDeliveryZone(): UseRestoreDeliveryZoneResult {
  const { enqueueSnackbar } = useSnackbar();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const restoreDeliveryZone = async (deliveryZoneId: string): Promise<DeliveryZone | null> => {
    setIsSubmitting(true);

    try {
      const restoredDeliveryZone = await HttpClient.post<DeliveryZone>(
        ADMIN_DELIVERY_ZONES_API_PATHS.RESTORE_DELIVERY_ZONE(deliveryZoneId)
      );

      enqueueSnackbar('Zone de livraison restaurée', { variant: 'success' });
      return restoredDeliveryZone;
    } catch (error) {
      enqueueSnackbar(
        extractTranslatedApiErrorMessage(
          error,
          'Une erreur est survenue lors de la restauration de la zone de livraison'
        ),
        { variant: 'error' }
      );
      return null;
    } finally {
      setIsSubmitting(false);
    }
  };

  return { restoreDeliveryZone, isSubmitting };
}
